<template>
  <Card class="mb-3">
    <div v-if="!onlyDates" class="cardTitle">{{ $t('Стадии процедуры') }}</div>
    <DateTimePicker
      required
      label="Приём заявок до"
      v-model="procedure.applicationDeadline"
      :error="errors['applicationDeadline']"
      :disabled-date="disabledDate"
      :deafaultNow="false"
      :appendToBody="appendToBody"
      @input="errors['applicationDeadline'] = null"
      @update:model-value="applicationDeadlineChanged"
      :lang="lang"
    />
    <DateTimePicker
      required
      label="Подведение итогов"
      v-model="procedure.summingStart"
      :error="errors['summingStart']"
      :deafaultNow="false"
      :disabled-date="disabledDate"
      :appendToBody="appendToBody"
      @input="errors['summingStart'] = null"
      @update:model-value="summingStartChanged"
      :lang="lang"
    />
  </Card>
</template>

<script setup lang="ts">
import Card from '@intec/vue-components/form/Card.vue';
import DateTimePicker from '@intec/vue-components/form/DateTimePicker.vue';
import Config from '@/config';

interface Props {
  procedure: Object,
  errors: Object,
  onlyDates: Boolean,
  appendToBody: Boolean,
  disabledDate: Function,
}

const props = withDefaults(defineProps<Props>(), {
  onlyDates: false,
  appendToBody: true,
  disabledDate: () => false,
});
const lang = Config.getUser().getLang();

props.procedure.applicationDeadline = props.procedure.applicationDeadline
    ? new Date(props.procedure.applicationDeadline)
    : null;
props.procedure.summingStart = props.procedure.summingStart
    ? new Date(props.procedure.summingStart)
    : null;

const clearDateErrors = () => {
  props.errors.applicationDeadline = null;
  props.errors.summingStart = null;
};

const validateRequired = (newValue, fieldName) => {
  let hasErrors = false;
  if (newValue === '' || newValue === null) {
    props.errors[fieldName] = 'Это поле обязательно для заполнения';
    hasErrors = true;
  }
  return hasErrors;
};

const applicationDeadlineChanged = (newValue) => {
  clearDateErrors();

  if (validateRequired(newValue, 'applicationDeadline')) return;

  const now = new Date();
  if (newValue < now) {
    props.errors.applicationDeadline = 'Приём заявок не может быть раньше текущей даты';
    return;
  }
  if (props.procedure.summingStart && newValue > props.procedure.summingStart) {
    props.errors.summingStart = 'Подведение итогов не может быть раньше даты приема заявок'
  }
};

const summingStartChanged = (newValue) => {
  clearDateErrors();

  if (validateRequired(newValue, 'summingStart')) return;

  const now = new Date();
  if (newValue < now) {
    props.errors.summingStart = 'Подведение итогов не может быть раньше текущей даты';
    return;
  }

  if (props.procedure.applicationDeadline && props.procedure.applicationDeadline > newValue) {
    props.errors.summingStart = 'Подведение итогов не может быть раньше даты приема заявок';
  }
}

const validate = async () => {
  clearDateErrors();

  const now = new Date();
  let valid = true;

  // Проверка на обязательность.
  if (validateRequired(props.procedure.applicationDeadline, 'applicationDeadline')) {
    valid = false;
  }
  if (validateRequired(props.procedure.summingStart, 'summingStart')) {
    valid = false;
  }

  // Проверка на дату в прошлом.
  if (props.procedure.applicationDeadline && props.procedure.applicationDeadline < now) {
    props.errors.applicationDeadline = 'Приём заявок не может быть раньше текущей даты';
    valid = false;
  }

  if (props.procedure.summingStart && props.procedure.summingStart < now) {
    props.errors.summingStart = 'Подведение итогов не может быть раньше текущей даты';
    valid = false;
  }

  // Логические зависимости.
  if (props.procedure.applicationDeadline
      && props.procedure.summingStart
      && props.procedure.applicationDeadline > props.procedure.summingStart
  ) {
    props.errors.summingStart = 'Подведение итогов не может быть раньше даты приема заявок';
    valid = false;
  }

  return valid;
};

defineExpose({
  validate
});
</script>
